export default "__VITE_ASSET__aR1j_Hhe__"